export default __webpack_public_path__ + "static/media/babel.88772600.svg";